import React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import styles from './RoadsideNeedServicing.module.scss';

const NeedServicing = ({ data }) => {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getImageUrl = (imageField) => {
    if (!imageField?.fields) return '';

    const getImageUrlFromField = (field) => {
      if (!field?.value?.src) return '';
      return field.value.src;
    };

    if (isMobile) {
      return (
        getImageUrlFromField(imageField.fields.mobileImage) ||
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    if (isTablet) {
      return (
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    return getImageUrlFromField(imageField.fields.desktopImage) || '';
  };

  const imageUrl = getImageUrl(data?.image);
  const title = data?.title || '';
  const text = data?.text || '';
  const buttonText = data?.buttonText || '';
  const buttonUrl = data?.buttonUrl || '';

  const backgroundStyle = {
    backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 54.42%, #000000 100%), url(${imageUrl})`,
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.content} data-aos="fade-up">
        <div className={styles.content_left}>
          <div dangerouslySetInnerHTML={{ __html: title }} />
          <p dangerouslySetInnerHTML={{ __html: text }} />
        </div>
        <div className={styles.content_buttonContainer}>
          <a href={buttonUrl} className={styles.content_buttonContainer_button}>
            {buttonText}
          </a>
        </div>
      </div>
      <div style={backgroundStyle} className={styles.image} data-aos="fade-up" />
    </div>
  );
};

export default NeedServicing;
